export const apiPrefix = '/api/v1';
